import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';

export const TNA_CREATE_TEMPLATE_FORM_MODEL = {
  createModel: (): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'INPUT',
            subType: 'text',
          },
          metadata: {
            keyName: 'name',
            label: 'Name of the template:',
            isRequired: true,
          },
        },
      ],
      isValid: false,
      colConfig: 'SINGLE_COL',
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },
};
